// libs
import { useCallback, useContext, useEffect } from "react";

// constants
import { FeatureFlag } from "../../constants/FeatureFlags";

// defs
import { IFeatureFlagsMap } from "@defs/FeatureFlags";

// services
import { useGetFeatureFlags } from "../../services/FeatureFlagService";

// context
import { UserInfoContext } from "@store/context/UserInfo";

interface IFeatureFlags {
    featureFlags: IFeatureFlagsMap;
    isFeatureEnable: (featureFlag: FeatureFlag) => boolean;
}

const useFeatureFlags = (userAlias: string, enableFetch: boolean = true): IFeatureFlags => {
    const { featureFlags: globalFeatureFlags, setFeatureFlags } = useContext(UserInfoContext);

    // Only fetch if not already in global context
    const { data: featureFlags } = useGetFeatureFlags(userAlias, enableFetch && !globalFeatureFlags);

    // Store fetched feature flags in global context
    useEffect(() => {
        if (featureFlags && !globalFeatureFlags) {
            setFeatureFlags(featureFlags);
        }
    }, [featureFlags, globalFeatureFlags, setFeatureFlags]);

    const effectiveFeatureFlags = globalFeatureFlags || featureFlags;

    const isFeatureEnable = useCallback(
        (featureFlag: FeatureFlag) => {
            return !!effectiveFeatureFlags && effectiveFeatureFlags[featureFlag]?.enabled;
        },
        [effectiveFeatureFlags],
    );

    return {
        isFeatureEnable,
        featureFlags: effectiveFeatureFlags,
    };
};

export default useFeatureFlags;
